<ng-container [formGroup]="formGroup">

  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Shareholders</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="addShareholder()">
        Add a Shareholder
      </lds-button>
    </div>
  </div>

  <div formArrayName="shareholders">
    <ng-container *ngIf="form.controls.length > 0; else tplNoShareholders">
      <app-inline-item
        *ngFor="let shareholderForm of form.controls; let i = index"
        [form]="shareholderForm"
        [formGroupName]="i"
        [isExpandable]="true"
        [initiallyExpanded]="expandedIndex === i"
        (delete)="removeShareholder(i)">
        <inline-summary>
          <div class="row">
            <div class="col-9">
              {{ shareholderForm.controls.contact.value?.name }}
            </div>
            <div class="col">
              {{ shareholderForm.controls.ownership.value | percent }}
            </div>
          </div>
        </inline-summary>
        <inline-content>
          <div class="row">
            <div class="col-9">
              <app-contact-search formControlName="contact" label="Director">
              </app-contact-search>
            </div>

            <div class="col-3">
              <spark-shared-percentage
                formControlName="ownership"
                label="Share"
                [validations]="{
                  custom: 'Must not exceed 100%'
                }">
              </spark-shared-percentage>
            </div>
          </div>
        </inline-content>
      </app-inline-item>
    </ng-container>
    <ng-template #tplNoShareholders>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      required: 'At least one shareholder is required',
      minlength: 'At least one shareholder is required',
      aggregated: 'Total share must not exceed 100%'
    }">
  </lds-form-feedback>
</ng-container>
